import { PaginationComponent } from "./pagination";

import { WorkspaceSearchResult } from "~/.server/api/routers/workspace";
import NoResultsAlert from "./noResultsAlert";
import { WorkspaceCard } from "./workspaceListItems";
import { calculateNumberOfItemsShown } from "~/utils/misc";

export default function WorkspaceList({ 
  data, 
  createPageUrl,
  pageSize,
  showMap,
}: { 
  data?: WorkspaceSearchResult;
  createPageUrl: (page: number) => string;
  pageSize: number;
  showMap: boolean
}) {
  if (!data?.workspaces.length) {
    return <NoResultsAlert />;
  }

  const gridLayout = showMap ? 'grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4' : 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6'
  return (
    <>
      <div className={`grid ${gridLayout}`}>
        {data.workspaces.map((space) => <WorkspaceCard key={space.id} {...space} />)}
      </div>

      {data.pagination.totalPages > 1 && (
        <div className="flex flex-col items-center gap-4 mt-8">
          <div className="text-xs text-muted-foreground">
            Mostrando{" "}
            <strong>
              {calculateNumberOfItemsShown({
                currentPage: data.pagination.currentPage,
                totalCount: data.pagination.totalCount,
                pageSize,
              })}
            </strong>{" "}
            de <strong>{data.pagination.totalCount}</strong> espacios
          </div>
          <PaginationComponent
            currentPage={data.pagination.currentPage}
            totalPages={data.pagination.totalPages}
            createPageUrl={createPageUrl}
          />
        </div>
      )}
    </>
  );
}
